import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import _ from "lodash";
import WOService from "src/Services/API/wo.service";
import UserService from "src/Services/API/user.service";
import { handleError, getAssignedTechsNameArray, isAdmin } from "src/Common/function";
import LoadMoreButton from "src/Components/Common/loadmorebutton";
import WOStatusComponent from "../WO/Components/Status/wostatuscomponent";
import BranchBar from "src/Components/branchbar/BranchBar";
import WoType from "src/Pages/WO/Components/Types/WoType";
import Highlight from "src/Components/Common/Highlight";

function Recommendations() {
  const [searchParams] = useSearchParams();
  const branch = Number(searchParams.get("branch"));

  // const keyword = useSelector((state) => state.Keyword.keyword);
  const [orderArray, setOrderArray] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [loadMoreButtonShown, setLoadMoreButtonShown] = useState(false);

  const keyword = searchParams.get("keyword") || "";

  useEffect(() => {
    setPageNumber(0);
    getAllRecommendations([], 0);
  }, [branch, keyword]);

  const getAllRecommendations = (previousOrderArray, pNumber) => {
    WOService.getAllRecommendations(keyword, pNumber, branch)
      .then((response) => {
        console.log("AAAAAAAA: ", response.data, "OrderArray: ", orderArray);
        if (response.status == 200) {
          let temp = [...previousOrderArray, ...response.data.orders];
          for (let i = 0; i < temp.length; i++) {
            temp[i].techNames = getAssignedTechsNameArray(temp[i].assignedTechs);
          }
          setOrderArray(temp);

          if (temp.length >= response.data.totalCount) {
            setLoadMoreButtonShown(false);
          } else {
            setLoadMoreButtonShown(true);
          }
        }
      })
      .catch((error) => {
        console.log("error: ", error);
        handleError(error);
      });
  };

  const handleLoadMore = () => {
    getAllRecommendations(orderArray, pageNumber + 1);
    setPageNumber(pageNumber + 1);
  };

  return (
    <div className="w-full h-full flex flex-col bg-backgroundColor">
      <div className=" flex-1 min-h-0 flex flex-col">
        <div className="px-5 py-2 border-b border-borderColor">
          <BranchBar />
        </div>
        <div className="p-5 flex-1 min-h-0 flex flex-col">
          <div
            className="w-full flex-1 min-h-0 flex flex-col overflow-hidden"
            style={{
              borderRadius: "12px",
              border: "1px solid #E5E8F3",
              background: "#FFF",
              boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.00), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
            }}
          >
            <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
              <table className="w-full">
                <thead className="sticky top-0 z-10 bg-[#F8F9FE]">
                  <tr
                    style={{ borderBottom: "1px solid #E5E8F3", background: "#F8F9FE" }}
                    className="[&>th]:border-r [&>th]:border-borderColor [&>th:last-child]:border-r-0"
                  >
                    <th>
                      <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center justify-center pl-4 w-[100px] h-[44px] text-[#5F6477] text-center">
                        <span>WO#</span>
                      </div>
                    </th>
                    <th>
                      <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center pl-4 w-[120px] h-[44px] text-[#5F6477]">
                        Type
                      </div>
                    </th>
                    <th>
                      <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center pl-4 w-[230px] h-[44px] text-[#5F6477]">
                        Customer
                      </div>
                    </th>
                    <th className="w-full">
                      <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center pl-4 h-[44px] text-[#5F6477]">
                        Recommendations
                      </div>
                    </th>
                    <th>
                      <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center pl-4 w-[250px] h-[44px] text-[#5F6477]">
                        Technician
                      </div>
                    </th>
                    <th>
                      <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center pl-4 w-[130px] h-[44px] text-[#5F6477]">
                        Status
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {orderArray.map((order, index) => (
                    <tr
                      key={index}
                      className="border-b border-borderColor hover:bg-[#FAFAFB] [&>td]:border-r [&>td]:border-borderColor [&>td:last-child]:border-r-0"
                    >
                      <td>
                        <div className="font-OpenSansRegular px-4 py-3 text-center text-[13px] leading-[20px] font-[400] text-[#1A2332] col-span-1">
                          <Highlight text={order.number} keyword={keyword} />
                        </div>
                      </td>
                      <td>
                        <div className="mx-auto flex justify-center">
                          <WoType serviceType={order.serviceType} />
                        </div>
                      </td>
                      <td>
                        <div className="font-OpenSansRegular px-4 py-3 text-[13px] leading-[20px] font-[400] text-[#1A2332] word-break-break-word">
                          <Highlight text={order.customer?.companyName} keyword={keyword} />
                        </div>
                      </td>
                      <td>
                        <div className="font-OpenSansRegular px-4 py-3 text-[13px] leading-[20px] text-[#1A2332] text-ellipsis word-break-break-word">
                          <Highlight text={order.recommendations} keyword={keyword} />
                        </div>
                      </td>
                      <td>
                        <div className="font-OpenSansRegular px-4 py-3 text-[13px] leading-[20px] text-[#1A2332] text-ellipsis word-break-break-word">
                          <Highlight text={order.techNames} keyword={keyword} />
                        </div>
                      </td>
                      <td>
                        <div className="px-4 py-3 flex items-center gap-3">
                          <WOStatusComponent value={order.status} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {loadMoreButtonShown && (
                <div className="w-full py-[10px] flex justify-center bg-white">
                  <LoadMoreButton onClicked={handleLoadMore} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Recommendations;
